import { useModalRootContext } from '@vkontakte/vkui';
import { useEffect } from 'react';

export const useSetModalHeight = () => {
    const { updateModalHeight } = useModalRootContext();
    useEffect(updateModalHeight);
};
